import { render, staticRenderFns } from "./CustomerComplaintReport.vue?vue&type=template&id=a1fca318"
import script from "./CustomerComplaintReport.vue?vue&type=script&lang=js"
export * from "./CustomerComplaintReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports